import React from 'react';
import { Column } from '@codeparva/ui-components-library';
import { updateContactLabels } from '../../constants/accountPanelConfigs';
import { Formik } from 'formik';
import { UpdateContactDetailsForm } from '../Form/UpdateContactDetailsForm';
import { UpdateContactDetailsTypes } from '../../UpdateContactDetailsTypes';
import { frameTenantUpdateRequest } from '../../helpers/UpdateContactDetailsHelper';
import { contactDetailsRestrictedFormSchema } from '../../helpers/updateContactDetailsFormSchema';
import { Icon } from '../../../../utilities/icomoon-css';

export const UpdateContactDetails = ({
  address,
  email,
  name,
  phone,
  callBackHandler,
  alternateEmail,
}: UpdateContactDetailsTypes.TUpdateContactDetailsComponent) => {
  const { mainTitle, contactFacility } = updateContactLabels;
  const { first_name = '', last_name = '' } = name;
  const { email_address = '' } = email;
  const initialValues = {
    first_name,
    last_name,
    email_address,
    ...(phone?.phone_number_list && { phone: phone?.phone_number_list }),
    ...(address && { address }),
    ...(alternateEmail && { alternate_email: alternateEmail }),
  };

  return (
    <>
      <Column className="contactDetailsParentSection">
        <h5 className="sectionContentTitle">{mainTitle}</h5>
        <div className="contactFacilityLabel">
          <Icon name="tfw-danger-triangle-cp" />
          <p className="subtitle1 pl-3">{contactFacility}</p>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={contactDetailsRestrictedFormSchema}
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            const updateContactDetailsRequest = frameTenantUpdateRequest(
              values,
              initialValues
            );
            setSubmitting(false);
            await callBackHandler(updateContactDetailsRequest);
            resetForm();
          }}
        >
          <UpdateContactDetailsForm />
        </Formik>
      </Column>
    </>
  );
};
